<mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node
        class="flex space-x-1"
        *matTreeNodeDef="let node"
        matTreeNodePadding
    >
        <button
            mat-button
            (click)="onLeafClick(node)"
            class="!rounded-full !px-4 !text-primary-700 !tracking-wide"
            [ngClass]="{
                '!bg-primary-50': selectedNode === node,
            }"
        >
            {{ node.name }}
        </button>
    </mat-tree-node>

    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node
        class="flex space-x-1"
        *matTreeNodeDef="let node; when: hasChild"
        matTreeNodePadding
        matTreeNodeToggle
        [cdkTreeNodeTypeaheadLabel]="node.name"
    >
        <button
            mat-icon-button
            matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name"
        >
            <mat-icon class="mat-icon-rtl-mirror !text-tertiary-900">
                {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
        </button>
        <span class="text-tertiary-900 font-medium">
            {{ node.name }}
        </span>
    </mat-tree-node>
</mat-tree>
